/**
 * @author Brendan Magee, Umer Hassan
 * @desc List of platforms that are open to pitching
 * @example <platform-list default-filters="$ctrl.defaultFilters"
 *                         platforms="$ctrl.platforms"
 *                         render-radio-buttons="boolean"
 *                         selected-platform="$ctrl.selectedPlatform"
 *                         state="$ctrl.$state"
 *                         update-plans="$ctrl.updatePlans(type, pathsArray)">
 *          </platform-list>
 */

import template from './platformList.html';

class PlatformListController {
  constructor() {
    this.storyUrlPath = 'planning.list';
  }

  goToPlatform(platform) {
    this.state.go(this.storyUrlPath, {
      ...this.defaultFilters,
      pl: platform.path
    });
  }
}

PlatformListController.$inject = ['featureFlag'];

const platformList = {
  bindings: {
    defaultFilters: '<',
    platforms: '<',
    renderRadioButtons: '<',
    selectedPlatform: '<',
    state: '<',
    updatePlans: '&'
  },
  controller: 'PlatformListController',
  template
};

export default function (ngModule) {
  ngModule.component('platformList', platformList);
  ngModule.controller('PlatformListController', PlatformListController);
}
